import { Viewer, Worker } from '@react-pdf-viewer/core';
import {
  RenderCurrentScaleProps,
  RenderZoomOutProps,
  ZoomInIcon,
  ZoomOutIcon,
  zoomPlugin,
} from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';

export interface PdfViewerProps {
  src: string;
  enableZoom?: boolean;
  defaultScale?: number;
  className?: string;
}

export const PdfViewer = ({ src, enableZoom, defaultScale = 0.8, className }: PdfViewerProps) => {
  // const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const zoomPluginInstance = zoomPlugin();
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

  return (
    <div className={className}>
      {enableZoom && (
        <div className="h-8 flex gap-4 justify-end mb-6 [&_svg]:w-[20px] [&_svg]:h-[20px] [&>*]:h-full">
          <ZoomOut>
            {(props: RenderZoomOutProps) => (
              <button className="hover:bg-[rgba(0,0,0,0.1)] px-2 rounded" onClick={props.onClick}>
                <ZoomOutIcon />
              </button>
            )}
          </ZoomOut>

          <CurrentScale>
            {(props: RenderCurrentScaleProps) => (
              <span className="leading-[30px]">{`${Math.round(props.scale * 100)}%`}</span>
            )}
          </CurrentScale>
          <ZoomIn>
            {(props: RenderZoomOutProps) => (
              <button className="hover:bg-[rgba(0,0,0,0.1)] px-2 rounded" onClick={props.onClick}>
                <ZoomInIcon />
              </button>
            )}
          </ZoomIn>
        </div>
      )}

      <Worker workerUrl="https://unpkg.com/pdfjs-dist@4.2.67/build/pdf.worker.min.mjs">
        <Viewer
          fileUrl={src}
          defaultScale={defaultScale}
          theme="light"
          plugins={enableZoom ? [zoomPluginInstance] : []}
        />
      </Worker>
    </div>
  );
};
